import { Flex } from "@chakra-ui/react"


export const Cell = ({children, ...props}) => {
    return (
        <Flex
            as="td"
            border='1px solid #343434'
            {...props}
        >
            {children}
        </Flex>  
    )
}
